const news_list = [
    {
        title: "Apple Market Rally Struggles Outside Apple As Earnings Kick Off", 
        url: require("../../images/body/news/news1.png"),
        description: "The Dow Jones, S&P 500 and Nasdaq fell, even as Apple (AAPL) powered higher, boosted by reports of bullish iPhone production plans. Beneath the surface, market breadth continued to weaken while recent breakouts and buying opportunities struggled.",
    },
    {
        title: "Moderna Stock — Soon To Join S&P 500 — Rockets To Yet Another Record", 
        url: require("../../images/body/news/news2.png"),
        description: "Taiwan Semiconductor (TSM) tumbled on weak margins, fueling selling in several chip names. UnitedHealth (UNH) beat views while InMode (INMD) soared on preliminary results. ",
    },
    {
        title: "Biotech Stock Craters After FDA Panel Rejects Anemia Treatment", 
        url: require("../../images/body/news/news3.png"),
        description: "Delta Air Lines (DAL) and American Airlines (AAL) reported positive cash flow for the first time since the pandemic started. Banking giants generally reported solid Q2 results amid declining trading revenue and growing investment banking revenue. ",
    },
    {
        title: "Blue Origin Is About To Beat Virgin Galactic To This Milestone", 
        url: require("../../images/body/news/news4.png"),
        description: "JPMorgan (JPM) and Goldman Sachs (GS) beat forecasts. though the former released $3 billion in loan-loss reserves to bolster the bottom line. Bank of America (BAC) slightly missed revenue targets.",
    },
    {
        title: "Citigroup (C), Wells Fargo (WFC) and Morgan Stanley (MS) also topped estimates.", 
        url: require("../../images/body/news/news5.png"),
        description: "Citigroup (C), Wells Fargo (WFC) and Morgan Stanley (MS) also topped estimates. Most were little changed for the week, though Wells and Morgan Stanley rose modestly.",
    },
    {
        title: "Taiwan Semi's Margins Disappoint", 
        url: require("../../images/body/news/news6.png"),
        description: "Taiwan Semiconductor Manufacturing (TSM) met Q2 EPS views for an 18% gain, but its 50% gross profit margin of 50% slightly missed. The world's largest chip foundry guided higher for sales for the full year and through 2025, but its long-term gross margin target of 50% disappointed",
    },
  ];

export default news_list;